import {Component} from '@angular/core';

@Component({
    selector: 'blitz-basic-script-panel',
    templateUrl: 'panel.html'
    //styleUrls: ['blitz-basic-script.scss']
})
export class PanelComponent {
    constructor() {

    }
}
